import React from 'react';
import Debounce from 'react-debounce-component';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import { MATERIAL_TRANSITION_TIME } from 'swag-client-common/constants';
import classnames from 'classnames';
import { CONFIRM_BUTTONS_ATTRIBUTES } from '../../../../custom-store-admin/utils/constants';
import classes from './confirm-dialog.scss';
const rootClasses = {
  paper: classes.root
};
const titleClasses = {
  root: classes.titleRoot
};
export class ConfirmDialog extends React.Component {
  renderContent() {
    const {
      msg,
      onCancel,
      onConfirm,
      loading,
      cancelText,
      confirmText,
      buttonCancelClassName,
      buttonConfirmClassName,
      buttonsContainerClassName,
      buttonCancelDataAttribute,
      buttonConfirmDataAttribute,
      textClassName,
      contentClassName,
      isDisabled,
      FooterComponent
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: contentClassName
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.text, textClassName)
    }, msg), /*#__PURE__*/React.createElement(Debounce, {
      ms: MATERIAL_TRANSITION_TIME
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.buttonsContainer, buttonsContainerClassName)
    }, /*#__PURE__*/React.createElement(Button, {
      label: "Cancel",
      type: "defaultGrey",
      onClick: onCancel,
      dataButton: buttonCancelDataAttribute || CONFIRM_BUTTONS_ATTRIBUTES.CANCEL,
      className: classnames(classes.button, buttonCancelClassName)
    }, cancelText || 'Cancel'), /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      loading: loading,
      disabled: isDisabled,
      onClick: (...args) => {
        if (loading) {
          return null;
        }
        onConfirm(...args);
      },
      dataButton: buttonConfirmDataAttribute || CONFIRM_BUTTONS_ATTRIBUTES.OK,
      className: classnames(classes.button, buttonConfirmClassName)
    }, confirmText || 'OK')), FooterComponent && /*#__PURE__*/React.createElement(FooterComponent, null)));
  }
  render() {
    const {
      onClose,
      title = 'Confirm action',
      titleClassName,
      open,
      onCancel,
      rootContentClassName,
      headerless = false,
      dialogClassName,
      showCloseButton,
      TransitionProps,
      disableScrollLock = true
    } = this.props;
    return /*#__PURE__*/React.createElement(PopupDialog, {
      popupClassName: dialogClassName,
      classes: rootClasses,
      dataPopup: "ConfirmAction",
      title: !headerless && title,
      titleHeader: classnames(classes.title, titleClassName),
      titleClasses: titleClasses,
      open: open,
      showCloseButton: showCloseButton,
      onClose: onClose || onCancel,
      content: this.renderContent(),
      contentClass: classnames(classes.content, rootContentClassName),
      TransitionProps: TransitionProps,
      disableScrollLock: disableScrollLock
    });
  }
}